import { useEffect, useState } from 'react';
import { Landing } from './components/Landing';
import { Room } from './components/Room';

const roomIdFromPath = (pathname: string): string | null => {
  const match = pathname.match(/^\/r\/([a-z0-9]{6,32})\/?$/);
  return match ? match[1] : null;
};

export const navigate = (path: string): void => {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

export const App = () => {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const roomId = roomIdFromPath(path);
  return roomId ? <Room roomId={roomId} /> : <Landing />;
};
